<template>
    <div class="kgk-user-team-create">
        <h3>Team erstellen</h3>
        <form @submit.prevent="createTeam">
            <div class="kgk-form-row">
                <div class="kgk-input-group">
                    <input type="text" v-model="name" placeholder="Teamname" style="text-align:center;">
                </div>
                <button type="submit">
                    <i v-if="loading" class="fas fa-spinner fa-spin fa-fw"></i>
                    <i v-else class="fas fa-users fa-fw"></i><!-- <i class="fas fa-users"></i> -->
                    <span class="button-text">Team erstellen</span>
                </button>
                <div v-if="name.length > 0 && name.length < 5" class="kgk-form-validation-error-inline">Bitte gib mindestens 5 Zeichen ein.</div>
            </div>
        </form>
    </div>
</template>

<script>
    import team from '../../api/team';

    export default {
        name: 'CreateTeam',
        props: {
            //msg: String
        },
        data() {
            return {
                loading: false,
                name: '',
                minLength: 5,
                error: '',
            }
        },
        computed: {

        },
        methods: {
            createTeam() {
                if( this.name.length < 5 ) {
                    return;
                }

                if( this.loading ) {
                    return;
                }

                this.loading = true;

                team.create(
                    this,
                    this.name,
                    data => {
                        console.log(data);
                        this.$notify({
                            type: 'success',
                            title: 'Team erstellt',
                            text: `Du hast das Team <b>${data.data.name}</b> erfolgreich erstellt.`
                        });

                        this.$emit('created');
                    },
                    e => {
                        //console.error(e.response.status);
                        if( e.response.status == 400 ) {
                            /*if( typeof e.response.data.field !== 'undefined' ) {
                                // maybe highlight error field
                            }*/

                            this.$notify({
                                type: 'error',
                                title: 'Fehler',
                                text: e.response.data.message
                            });
                            return;
                        }

                        this.$notify({
                            type: 'error',
                            title: 'Es ist ein unbekannter Fehler aufgetreten.',
                            text: 'Bitte versuch es noch einmal.'
                        });
                    },
                    () => this.loading = false
                )
            }
        },
        mounted() {

        }
    }
</script>

